@if (isAuthenticated) {
  <app-toolbar class="mat-elevation-z6" />
  <router-outlet />
} @else {
  <div class="auth-loading">
    <p>Authenticating...</p>
  </div>
}
@if (updateAlertVisible()) {
  <xui-banner bgColorClass="dark" message="This application has been updated. Please reload to get the latest features." primaryActionText="Reload" secondaryActionText="Dismiss" (primaryAction)="reload()" (secondaryAction)="updateAlertVisible.set(false)"></xui-banner>
}
